import { render, staticRenderFns } from "./StudentScholarshipCreate.vue?vue&type=template&id=9fc48568"
import script from "./StudentScholarshipCreate.vue?vue&type=script&lang=js"
export * from "./StudentScholarshipCreate.vue?vue&type=script&lang=js"
import style0 from "./StudentScholarshipCreate.vue?vue&type=style&index=0&id=9fc48568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports